import { gql, useQuery } from '@apollo/client';
import { Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { EventPromotionBox } from '@/imports/ui/components/EventPromotionBox';

import {
  PromotionCard_FeaturedSponsorOrganization,
  PromotionCard_FeaturedSponsorOrganizationVariables,
} from './graphql-types/PromotionCard_FeaturedSponsorOrganization';

const FEATURED_SPONSOR_ORGANIZATION = gql`
  query PromotionCard_FeaturedSponsorOrganization(
    $input: SingleOrganizationInput!
  ) {
    organization(input: $input) {
      result {
        _id
        name
        sponsorship {
          currentTier {
            analyticsTierType
          }
          ad(input: { filters: { includeUnpublished: false } }) {
            _id
            title
            body
            registerInterestTitle
            callToAction
            url
            adImage {
              _id
              imageProxy(input: { w: 560 })
            }
          }
        }
      }
    }
  }
`;

export const PromotionCard: React.FC<{
  eventId: string;
  organizationId: string;
  title: string;
}> = ({ eventId, organizationId, title }) => {
  const { data, loading } = useQuery<
    PromotionCard_FeaturedSponsorOrganization,
    PromotionCard_FeaturedSponsorOrganizationVariables
  >(FEATURED_SPONSOR_ORGANIZATION, {
    variables: { input: { id: organizationId } },
    skip: !organizationId,
  });

  const organization = data?.organization?.result ?? null;
  const sponsorship = organization?.sponsorship ?? null;
  const ad = sponsorship?.ad ?? null;

  if (loading || !organization || !ad) {
    return null;
  }

  return (
    <Stack>
      <Card px="4" py="6">
        <Stack spacing="4">
          <Text
            textStyle="compactStrong"
            color="gray.600"
            textTransform="uppercase"
          >
            {title}
          </Text>
          <EventPromotionBox
            title={ad.title || ''}
            body={ad.body || ''}
            registerInterestTitle={ad.registerInterestTitle || ''}
            callToAction={ad.callToAction || ''}
            url={ad.url || ''}
            organizationName={organization.name}
            organizationId={organization._id}
            image={ad.adImage?.imageProxy || undefined}
            origin={{ hostedEventId: eventId }}
            analytics={{
              view: 'eventSimpleEvent',
              tier: sponsorship?.currentTier?.analyticsTierType ?? '',
            }}
            w="60"
          />
        </Stack>
      </Card>
    </Stack>
  );
};
